import React, { useEffect, useRef, useState } from "react";
import io from "socket.io-client";
import Peer from "simple-peer";
import styled from "styled-components";
import i_close from '../../UI/svg/Close.svg';
import icons from '../../utils/import.icons';
import { tourLogin } from '../renders.dao';

const Container = styled.div`
    position: absolute;
    z-index: 9999;
    right: 0;
    top: 0;
    padding: 0;
    display: flex;
    margin: auto;
    flex-wrap: wrap;
    flex-direction: column;
`;

const StyledVideo = styled.video`
    height: 180px;
    width: 180px;    
`;

// TODO: move video component to its own file

const Video = (props) => {
    const ref = useRef();

    let [muted, setMuted] = useState(props.muted || false);

    useEffect(() => {
        props.peer.on("stream", stream => {
            ref.current.srcObject = stream;
        })
    }, []);

    return (
        <div 
        className="peer-slot"
        >
            <div
            className="peer-controls"
            >
                {
                    props.isHost ?
                    <>
                        <button type="button"
                        onClick={props.grantFullControl}
                        >
                            <img className="tour-icon" src={
                                props.leadingPeer ?
                                icons['follow_on']
                                :
                                icons['follow_off']
                            } />
                        </button>
                        <button type="button"
                        onClick={props.grantSelfControl}
                        >
                            {
                                props.isLocked ?
                                <img className="tour-icon" src={icons['lock_on']} />
                                :
                                <img className="tour-icon" src={icons['lock_off']} />
                            }
                            
                        </button>
                        <button type="button"
                        onClick={props.kick}
                        >
                            <img className="tour-icon" src={icons['x']} />
                        </button>
                    </>
                    :
                    null
                }
                <button type="button"
                    onClick={()=>setMuted(!muted)}
                >
                    { muted ? 
                    <>
                        <img className="tour-icon" src={icons['mic_off']} /> 
                    </>
                    : 
                    <>
                        <img className="tour-icon" src={icons['mic_on']} />
                    </>
                    }
                </button>
            </div>
            
            <div className="tour-hud">
                {
                    props.isHost ?
                    null
                    :
                    props.leadingPeer ?          
                    <img className="tour-icon" src={icons['follow_on']} />
                    :   
                    null
                }
                <p>{props.name}</p>
            </div>
            
            <StyledVideo muted={muted} playsInline autoPlay ref={ref} />
        </div>        
    );
}

const videoConstraints = {
    width: { ideal: 480 },
    height: { ideal: 480 }
};

class Room extends React.Component {

    constructor(props) {
        super(props);
        
        this.state = {
            peers: [],
            isConnected: false,
            logingIn: false,
            isHost: false,
            hasControl: false,
            muted: true,
            startAudio: true,
            startVideo: true,
            isLocked: true,
            leadingPeer: null,
            showHud: true,
            roomFull: false
        }
    
        //this.peers = useState([]);
        this.socketRef = React.createRef();
        this.userVideo = React.createRef();
        this.peersRef = /*React.createRef(); //*/[]
        this.roomID = "byb-distrito-plaza";//props.match.params.roomID;
        
        this.newPayload = {}
    }

    componentDidMount () 
    {
        if (document.addEventListener) {
            document.addEventListener('contextmenu', (e) => {
                //console.log("You've tried to open context menu"); //here you draw your own menu
                if(!this.state.logingIn){
                    this.setState({
                        showContextMenu: true,
                        ctxTop: e.pageY-10,
                        ctxLeft: e.pageX-40
                    })
                }
                
                e.preventDefault();
                /*let menu = document.createElement("div")
                menu.id = "ctxmenu"
                menu.style = `top:${e.pageY-10}px;left:${e.pageX-40}px`
                menu.onmouseleave = () => menu.outerHTML = ''
                menu.innerHTML = "<p>Option1</p><p>Option2</p><p>Option3</p><p>Option4</p><p onclick='alert(`Thank you!`)'>Upvote</p>"
                document.body.appendChild(menu)*/
                
            }, false);
        } else {
            document.attachEvent('oncontextmenu', function(e) {
                
                if(!this.state.logingIn){
                    this.setState({
                        showContextMenu: true,
                        ctxTop: e.pageY-10,
                        ctxLeft: e.pageX-40
                    })
                }
                //console.log("You've tried to open context menu (attach)");
                window.event.returnValue = false;
            });
        }

        /* Dragging */

        dragElement(document.getElementById("peer-slot-container"));

        function dragElement(elmnt) {
        var pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
        if (document.getElementById(elmnt.id + "-header")) {
            // if present, the header is where you move the DIV from:
            document.getElementById(elmnt.id + "-header").onmousedown = dragMouseDown;
            document.getElementById(elmnt.id + "-header").ontouchstart = dragMouseDown;
        } else {
            // otherwise, move the DIV from anywhere inside the DIV:
            elmnt.onmousedown = dragMouseDown;
            elmnt.ontouchstart = dragMouseDown;
        }

        function dragMouseDown(e) {
            e = e || window.event;
            e.preventDefault();
            // get the mouse cursor position at startup:
            pos3 = e.type.indexOf('touch') === 0 ? e.changedTouches[0].clientX : e.clientX;
            pos4 = e.type.indexOf('touch') === 0 ? e.changedTouches[0].clientY : e.clientY;

            document.onmouseup = closeDragElement;
            document.ontouchend = closeDragElement;
            // call a function whenever the cursor moves:
            document.onmousemove = elementDrag;
            document.ontouchmove = elementDrag;
        }

        function elementDrag(e) {
            e = e || window.event;
            if(e.type.indexOf('touch') !== 0){
                e.preventDefault();
            }
            
            // calculate the new cursor position:
            pos1 = pos3 - (e.type.indexOf('touch') === 0 ? e.changedTouches[0].clientX : e.clientX);
            pos2 = pos4 - (e.type.indexOf('touch') === 0 ? e.changedTouches[0].clientY : e.clientY);
            pos3 = e.type.indexOf('touch') === 0 ? e.changedTouches[0].clientX : e.clientX;
            pos4 = e.type.indexOf('touch') === 0 ? e.changedTouches[0].clientY : e.clientY;
            // set the element's new position:
            elmnt.style.top = Math.max(0, Math.min(window.innerHeight - elmnt.offsetHeight, elmnt.offsetTop - pos2)) + "px";
            elmnt.style.left = Math.max(-window.innerWidth, Math.min(0 - elmnt.offsetWidth, elmnt.offsetLeft - pos1)) + "px";
        }

        function closeDragElement() {
            // stop moving when mouse button is released:
            document.onmouseup = null;
            document.onmousemove = null;
            document.ontouchend = null;
            document.ontouchmove = null;
        }
        }
    }    

    updateDataHandler = (data) => {
        //console.log('got peer data'/*, JSON.parse(data.toString())*/)
        this.props.updateFromTourData(JSON.parse(data.toString()));
    }

    createPeer = (userToSignal, callerID, stream, name) => {
        const peer = new Peer({
            initiator: true,
            trickle: false,
            /*name,*/
            config: { 
                iceServers:
                [
                    { urls: 'stun:stun.l.google.com:19302' }, 
                    { urls: 'stun:global.stun.twilio.com:3478?transport=udp' },
                    //{ urls: 'stun:172.31.23.133:5349?transport=udp' }
                    /*{ 
                        urls: 'turn:172.31.23.133:3478?transport=tcp',
                        username: 'cassia47',
                        credential: '1Nt3r4ct1v3'
                    },
                    { 
                        urls: 'stun:172.31.23.133:3478?transport=udp'
                    }*/
                ] 
            },
            stream           
        });

        peer.on("signal", signal => {
            //console.log('signal at created:', signal )
            this.socketRef.current.emit("sending signal", { userToSignal, callerID, signal/*, name*/ })
            
            peer.on('data', data => this.updateDataHandler(data));
        })        

        return peer;
    }

    addPeer = (incomingSignal, callerID, stream, name)  => {
        const peer = new Peer({
            initiator: false,
            trickle: false,
            /*name,*/
            config: { 
                iceServers:
                [
                    { urls: 'stun:stun.l.google.com:19302' }, 
                    { urls: 'stun:global.stun.twilio.com:3478?transport=udp' },
                    //{ urls: 'stun:172.31.23.133:5349?transport=udp' }
                    /*{ 
                        urls: 'turn:172.31.23.133:3478?transport=tcp',
                        username: 'cassia47',
                        credential: '1Nt3r4ct1v3'
                    },
                    { 
                        urls: 'stun:172.31.23.133:3478?transport=udp'
                    }*/
                ] 
            },
            stream
        })

        peer.on("signal", signal => {
            //console.log('signal at added:', signal)
        this.socketRef.current.emit("returning signal", { signal, callerID/*, name*/ })
        })

        peer.on('data', data => this.updateDataHandler(data));

        peer.signal(incomingSignal);

        return peer;
    }

    receiveControl = (control) => {
        this.setState({
            hasControl: control
        })
        this.props.updateHasControl(control);
    }

    toggleVideo = (value) => {
        this.userVideo.current.srcObject.getVideoTracks().forEach(track => {
            track.enabled = value;
        });
    }

    toggleAudio = (value) => {
        this.userVideo.current.srcObject.getAudioTracks().forEach(track => {
            track.enabled = value;
        });
    }

    connect = (isHost) => {

        this.setState({
            isConnecting: true,
            mediaError: false
        });
        
        //this.socketRef.current = io.connect("https://shrouded-plains-96767.herokuapp.com/");
        //this.socketRef.current = io.connect("localhost:8000/");
        //this.socketRef.current = io.connect("https://guided-tour-server-staging.herokuapp.com/");
        this.socketRef.current = io.connect("https://byb-distrito-plaza-guided-tour.herokuapp.com/");

        navigator.mediaDevices.getUserMedia({ video: videoConstraints, audio: true }).then(stream => {

            this.userVideo.current.srcObject = stream;

            /*var result = stream.getVideoTracks().some(function(track) {
                
                return track.enabled && track.readyState === 'live';
            });*/
            
            /*if (result) {
                alert('Your webcam is busy!');
                console.log('Your webcam is busy!')
            } else {
                alert('Not busy');
                console.log('not busy')
            }*/

            this.toggleAudio(this.state.startAudio);
            this.toggleVideo(this.state.startVideo);

            this.socketRef.current.emit("join room", { 
                roomID: this.roomID,
                name: this.state.name
            });
            
            //console.log('trying to join room', this.roomID)
            
            this.socketRef.current.on("all users", users => {

                this.setState({
                    logingIn: false,
                    isConnecting: false,
                    isConnected: true                    
                });

                const peers = [];
                
                users.forEach(user => {
                    //console.log('users foreach: ', user.socketID)
                    const peer = this.createPeer(user.socketID, this.socketRef.current.id, stream, this.state.name);
                    this.peersRef.push({
                        peerID: user.socketID,
                        name: user.name,
                        peer
                    })
                    peers.push({
                        peerID: user.socketID,
                        name: user.name,
                        peer
                    });
                })

                // here
                this.setState(prevState => ({
                    peers: peers
                }),
                ()=>{
                    //console.log('[all users] state.peers:', this.state.peers)

                    if(isHost){
                        this.setState({
                            isHost: true
                        })
    
                        this.receiveControl(true);
                        
                        this.socketRef.current.emit("set host", this.roomID);
                        this.retakeFullControl(); // net
                    } else {
                        this.setState({
                            isHost: false
                        })
    
                        this.receiveControl(false);
    
                        this.blockSelfControl();
                    }
                });

            })

            this.socketRef.current.on("user joined", payload => {
                const peer = this.addPeer(payload.signal, payload.callerID, stream, payload.name);
                this.peersRef.push({
                    peerID: payload.callerID,
                    name: payload.name,
                    peer
                })

                const peerObj = {
                    peerID: payload.callerID,
                    name: payload.name,
                    peer
                }

                // here
                this.setState(prevState => ({
                    peers: this.peersRef
                }),
                ()=>{
                    console.log('[user joined] state.peers:', this.state.peers)
                });

            });

            this.socketRef.current.on("receiving returned signal", payload => {
                const item = this.peersRef.find(p => p.peerID === payload.id);
                item.peer.signal(payload.signal);
            });

            this.socketRef.current.on("user left", id => {
                const peerObj = this.peersRef.find(p => p.peerID === id);
                if(peerObj){
                    peerObj.peer.destroy();
                }
                const peers = this.peersRef.filter(p => p.peerID !== id);
                this.peersRef = peers;

                // here
                this.setState(prevState => ({
                    peers: peers
                }),
                ()=>{
                    console.log('[user left] state.peers:', this.state.peers)
                });
            })

            this.socketRef.current.on("granting full control", payload => {
                //console.log('received instruction to grant full control', payload);
                
                if(payload.peerID === this.socketRef.current.id){
                    this.setState({
                        leadingPeer: payload.peerID
                    })
                    this.receiveControl(true);
                    console.log('control true')
                    this.props.setControlLock(false)    //care
                } 
                else
                {
                    this.setState({
                        leadingPeer: payload.peerID
                    })
                    this.receiveControl(false);
                    this.blockSelfControl();
                    //console.log('control false')
                }
            });

            this.socketRef.current.on("update lock", payload => {
                //console.log('received instruction to update lock', payload);
                if(!this.state.isHost){ // control lock affects only guests
                    this.props.setControlLock(payload)   
                }
                this.setState({
                    isLocked: payload
                })             
                
            });

            this.socketRef.current.on("get kicked", payload => {
                //console.log('received instruction to be kicked');
                //console.log(payload);
                //console.log(this.socketRef.current.id);
                if(payload.peerID === this.socketRef.current.id){
                    this.disconnect();
                }
            });

            this.socketRef.current.on("room full", () => {
                this.setState({
                    roomFull: true,
                    isConnected: false,
                    isConnecting: false
                })
                this.disconnect();
            })

        }).catch((error) => {
            // media error
            this.setState({
                mediaError: true,
                isConnected: false
            })
            console.log(error)
        })
    }

    componentDidUpdate(prevProps, prevState){
        if(prevProps !== this.props){
            if(this.state.hasControl){
                //console.log('Rrow update diff:');

                /*const now = Object.entries(this.props);
                this.newPayload = {}
                const added = now.filter(([key, val]) => {
                    //if (prevProps[key] === undefined) return true;
                    if (prevProps[key] !== val) {
                        this.newPayload[key] = val
                        
                    }
                    return false;
                });*/
                //added.forEach(([key, val]) => console.log(`${key} + ${JSON.stringify(val)}`));

                //let payload = JSON.stringify(this.props);
                this.state.peers.forEach(peer => {
                    if(peer.peer._channel && peer.peer._channel.readyState === "open"){
                        //console.log('sending props to peers', this.props)
                        peer.peer.send(JSON.stringify(this.props));
                    }
                    
                })
            }            
            //this.socketRef.current.emit("sending signal", { userToSignal, callerID, signal })
        }
    }

    loginAsHost = (e) => {
        e.preventDefault();
        
        //console.log(e.target.elements.pass.value)

        const target = e.target;
        const self = this
        
        this.setState({
            name: e.target.elements.name.value
        },
        ()=>{
            
        })
        if(!this.state.isConnected){
                
            tourLogin({
                name: target.elements.name.value,
                password: target.elements.pass.value
            }).then(res => {
                if(res.status === 200){
                    self.connect(true)
                }
            }).catch(error => {
                console.log('error:', error)
            })
            
        }
        
        
    }

    loginAsGuest = (e) => {
        e.preventDefault();

        this.setState({
            name: e.target.elements.name.value
        },
        ()=>{
            if(!this.state.isConnected){
                this.connect(false)
            }
        })

        
        
    }

    handleCloseLoginModal = () => {
        if(this.state.mediaError){
            this.setState({
                isConnecting: false,
                isConnected: false
            })
        }

        if(this.state.roomFull){
            this.setState({
                roomFull: false
            })
        }

        this.setState({
            logingIn: false,
            hostLogin: false
        })

    }

    /*** control */

    toggleInteractionLock = (forceState=null) =>
    {
        this.socketRef.current.emit("toggle lock", {
            roomID: this.roomID, 
            isHost: this.state.isHost,
            forceState: forceState
        });
    }

    grantFullControl = (peer) => {
        //console.log(peer)
        this.socketRef.current.emit("grant full control", { 
            roomID: this.roomID,
            peerID: peer.peerID
        });
        this.toggleInteractionLock(false);
    }

    grantSelfControl = () => {
        this.props.setControlLock(false);
    }

    blockSelfControl = () => {
        this.props.setControlLock(true);
    }

    retakeFullControl = () => {
        this.socketRef.current.emit("grant full control", { 
            roomID: this.roomID,
            peerID: this.socketRef.current.id
        });
        this.toggleInteractionLock(true);
    }

    kickPeer = (peer) => {
        this.socketRef.current.emit("kick peer", { 
            roomID: this.roomID,
            peerID: peer,
            isHost: this.state.isHost
        });
    }

    toggleHud = () => {
        this.setState({
            showHud: !this.state.showHud
        })
    }

    disconnect = () => {
        this.socketRef.current.disconnect();
        this.state.peers.forEach(peer => {
            peer.peer.destroy();
        });
        this.setState({
            isConnected: false,
            peers: []
        })
        this.peersRef = [];

        if(this.userVideo.current && this.userVideo.current.srcObject){
            this.userVideo.current.srcObject.getVideoTracks().forEach(track => {
                track.stop();
            });
            this.userVideo.current.srcObject.getAudioTracks().forEach(track => {
                track.stop();
            });
        }

        this.grantSelfControl();
    }

    render() {
        const {isConnected, isConnecting, peers, mediaError} = this.state;
        return (
            <Container>
                { // context menu
                    this.state.showContextMenu && !isConnected ? 
                    <div id="ctxmenu"
                    style={{
                        position: 'fixed',
                        left: `${this.state.ctxLeft}px`,
                        top: `${this.state.ctxTop}px`
                    }}
                    onMouseLeave={()=> {
                        this.setState({
                            showContextMenu: false
                        })
                    }}
                    >
                        <p 
                        onClick={()=> { 
                            //this.connect();
                            this.setState({
                                showContextMenu: false,
                                logingIn: true,
                                hostLogin: true,
                                mediaError: false
                            })
                            //console.log('connect?')
                        }}>Iniciar tour guiado como guía</p>
                        <p 
                        onClick={()=> { 
                            //this.connect();
                            this.setState({
                                showContextMenu: false,
                                logingIn: true,
                                hostLogin: false,
                                mediaError: false
                            })
                            //console.log('connect?')
                        }}>Iniciar tour guiado como invitado</p>
                    </div>
                    : 
                    null
                }

                { // login modal
                    this.state.logingIn ?
                    
                    <div 
                    className="login-modal"
                    >
                        {
                            isConnecting ?
                            <form>
                                {
                                mediaError ? 
                                <>
                                <button type="button" className="login-close" onClick={this.handleCloseLoginModal}><img src={i_close}/></button>
                                Tu cámara está ocupada
                                </>
                                :
                                <>
                                {
                                this.state.roomFull ?
                                <>
                                <button type="button" className="login-close" onClick={this.handleCloseLoginModal}><img src={i_close}/></button>
                                <p>
                                    La sala está llena, contacta al asesor
                                </p>
                                </>
                                :
                                <p>
                                    Iniciando    
                                </p>                                
                                }
                                </>
                                }
                            </form>
                            :
                            <form
                            onSubmit={
                                this.state.hostLogin ?
                                this.loginAsHost
                                :
                                this.loginAsGuest
                            }
                            >
                                <button type="button" className="login-close" onClick={this.handleCloseLoginModal}><img src={i_close}/></button>
                                <div>
                                    <label htmlFor="name">Nombre: </label><input type="text" name="name" placeholder="Nombre" required />
                                </div>
                                {
                                    this.state.roomFull ?
                                    <>
                                        <button type="button" className="login-close" onClick={this.handleCloseLoginModal}><img src={i_close}/></button>
                                        <p>
                                            La sala está llena, contacta al asesor
                                        </p>
                                    </>
                                    :
                                    (this.state.hostLogin ?
                                    <>
                                        <div>
                                            <label htmlFor="pass">Contraseña: </label><input type="password" name="pass" required />
                                        </div>                                    
                                    </>
                                    :
                                    
                                    <>
                                        {/*
                                            <div>
                                                <label htmlFor="pin">Pin: </label><input type="number" name="pin" required />
                                            </div>                                    
                                        */}
                                    </>)
                                }
                                
                                <div className="starting-options">
                                    <div>
                                        <label htmlFor="video"
                                        onClick={()=>{
                                            //console.log(this.state.startVideo)
                                            this.setState({
                                                startVideo: !this.state.startVideo
                                            })
                                        }}
                                        >
                                            <input type="checkbox" name="video" checked={this.state.startVideo} readOnly />
                                            <img src={icons['video_on']} />
                                        </label>
                                        
                                    </div>
                                    <div>
                                        <label htmlFor="audio"
                                        onClick={()=>{
                                            //console.log(this.state.startAudio)
                                            this.setState({
                                                startAudio: !this.state.startAudio
                                            })
                                        }}
                                        >
                                            <input type="checkbox" name="audio" checked={this.state.startAudio} readOnly />                                    
                                            <img src={icons['mic_on']} />
                                        </label>
                                    </div>
                                </div>

                                <br />
                                <input type="submit" value="Log In" />
                            </form>
                        }
                        
                    </div>
                    :
                    null
                }
                
                { 
                    !isConnected ? 
                    <button type="button"
                    className="tour-external-connect-btn"
                    onClick={()=>{
                        this.setState({
                            showContextMenu: false,
                            logingIn: true,
                            hostLogin: false
                        })
                    }}
                    >Conectar</button>
                    :
                    null
                }
                
                <div id="peer-slot-container">
                    <div id="peer-slot-container-header"
                    style={{
                        display: isConnected ? 'block' : 'none'
                    }}
                    >
                        <span>
                            ...
                        </span>
                        <button type="button"
                        className="toggle-hud"
                        onClick={this.toggleHud}
                        onTouchStart={this.toggleHud}
                        >
                            <img className="tour-icon" src={icons['arrow_down']} />
                        </button>
                    </div>
                    
                    <div
                    style={{
                        height: this.state.showHud ? 'auto' : 0,
                        overflow: 'hidden',
                        transition: 'all .3s ease'
                    }}
                    >
                    { // video UI 
                        (isConnected || isConnecting) && !mediaError ?
                        <>
                            <div 
                            className="peer-slot"
                            >
                                <div
                                className="peer-controls"
                                >
                                    {
                                        this.state.isHost ?
                                        <>
                                            <button type="button"
                                            onClick={this.retakeFullControl}
                                            >
                                                {
                                                    this.state.hasControl ?
                                                    <img className="tour-icon" src={icons['follow_on']} />
                                                    :
                                                    <img className="tour-icon" src={icons['follow_off']} />
                                                }
                                                
                                            </button>
                                            <button type="button"
                                            onClick={() => {
                                                this.toggleInteractionLock()
                                            }}
                                            >
                                                {
                                                    this.state.isLocked ? 
                                                        <img className="tour-icon" src={icons['lock_on']} />
                                                    :
                                                        <img className="tour-icon" src={icons['lock_off']} />
                                                }
                                            </button>
                                        </>
                                        :
                                        null
                                    }      
                                    <button type="button"
                                        onClick={()=>{ this.setState({
                                            startAudio: !this.state.startAudio
                                        },
                                        ()=> {
                                            this.toggleAudio(this.state.startAudio)
                                        })
                                        }
                                        }
                                        >
                                        { this.state.startAudio ? 
                                        <>
                                            <img className="tour-icon" src={icons['mic_on']} />
                                        </>
                                        : 
                                        <>
                                            <img className="tour-icon" src={icons['mic_off']} />
                                        </>
                                        }
                                    </button>
                                    <button type="button"
                                        onClick={()=>{
                                            this.setState({
                                                startVideo: !this.state.startVideo
                                            },
                                            ()=>{
                                                this.toggleVideo(this.state.startVideo)
                                            })
                                        }}
                                        >
                                        { this.state.startVideo ? 
                                        <>
                                            <img className="tour-icon" src={icons['video_on']} />
                                        </>
                                        : 
                                        <>
                                            <img className="tour-icon" src={icons['video_off']} />
                                        </>
                                        }
                                    </button>
                                    <button type="button"
                                        onClick={this.disconnect}
                                    >
                                        <img className="tour-icon" src={icons['hangup']} />
                                    </button>
                                </div>

                                <div className="tour-hud">
                                    {
                                        this.state.isHost ?
                                        null
                                        :
                                        this.socketRef.current ? 
                                        (this.state.leadingPeer === this.socketRef.current.id ?
                                        <img className="tour-icon" src={icons['follow_on']} />
                                        :
                                        null)
                                        :
                                        null                                                
                                    }
                                    <p>{this.state.name}</p>
                                </div>
                                <StyledVideo 
                                //name={this.state.name}
                                muted={true} ref={this.userVideo} autoPlay playsInline />
                            </div>                        
                            { 
                            mediaError ? 
                            null
                            :
                            peers.map((peer) => {
                                return (
                                    <Video       
                                    leadingPeer={this.state.leadingPeer === peer.peerID}
                                    isLocked={this.state.isLocked}
                                    muted={false}
                                    key={peer.peerID}
                                    peer={peer.peer}
                                    name={peer.name}
                                    grantFullControl={() => this.grantFullControl(peer)}
                                    grantSelfControl={() => {
                                        this.toggleInteractionLock()
                                    }}
                                    kick={() => this.kickPeer(peer.peerID)}
                                    isHost={this.state.isHost}
                                    />
                                );
                            })
                            }
                        </>
                        :
                        null
                    }
                    </div>
                </div>
            </Container>
        );
    }
};

export default Room;
